// extracted by mini-css-extract-plugin
export default {"container":"wV-z","disabled":"xV-z","bgBlack":"yV-z","content":"zV-z","countdown":"AV-z","topCaption":"BV-z","topHeading":"CV-z","heading":"DV-z","copy":"EV-z"};